export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_TYPING_USERS_REQUEST = "GET_TYPING_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";

export const SET_USERS = "SET_USERS";
export const SET_USER = "SET_USER";

export const SUBMIT_USER_REQUEST = "SUBMIT_USER_REQUEST";
export const SUBMIT_USER_SUCCESS = "SUBMIT_USER_SUCCESS";
export const SUBMIT_USER_FAILURE = "SUBMIT_USER_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const getUsersRequest = (filters = {}) => ({
    type: GET_USERS_REQUEST,
    payload: {
        filters,
        page: filters.page || 1
    }
});

export const getTypingUsersRequest = (filters = {}) => ({
    type: GET_TYPING_USERS_REQUEST,
    payload: {
        filters
    }
});

export const getUsersSuccess = (users, total, profiles, page = 1) => ({
    type: GET_USERS_SUCCESS,
    payload: {
        users,
        total,
        profiles,
        page
    }
});

export const getUsersFailure = err => ({
    type: GET_USERS_FAILURE,
    error: err
});

export const setUsers = (users = [], total = 0) => ({
    type: SET_USERS,
    payload: {
        users,
        total
    }
});

export const setUser = (user = {}) => ({
    type: SET_USER,
    payload: {
        user
    }
});

export const submitUsersRequest = (user, history) => ({
    type: SUBMIT_USER_REQUEST,
    payload: { user },
    history
});

export const submitUsersSuccess = user => ({
    type: SUBMIT_USER_SUCCESS,
    payload: {
        user
    }
});

export const submitUsersFailure = err => ({
    type: SUBMIT_USER_FAILURE,
    error: err
});

export const updateUserRequest = (user) => ({
    type: UPDATE_USER_REQUEST,
    payload: { user }
});

export const updateUserSuccess = (user) => ({
    type: UPDATE_USER_SUCCESS,
    payload: { user }
});

export const updateUserFailure = (err) => ({
    type: UPDATE_USER_FAILURE,
    error: err
});
